
export const defaultImage = "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA";

export const bitmapByteLength = ({width, height}) => Math.ceil(width / 8) * height;

export const createBitmap = (profile) => new Uint8Array(bitmapByteLength(profile));

export const encodeBitmap = (value) => btoa(String.fromCharCode(...new Uint8Array(value)));

export const decodeBitmap = (value, expectedBytes = 72) => {
  const encodedBitmapLength = Math.ceil(expectedBytes / 3) * 4;
  const a = value;
  if (!a) return false;
  const input = a.trim();
  try {
    const bitmap = new Uint8Array(
      [...atob(input.substring(0, encodedBitmapLength))].map((char) => char.charCodeAt(0))
    );
    return bitmap.length === expectedBytes ? bitmap : false;
  } catch {
    return false;
  }
};

export const getPixel = (bitmap, profile, x, y) => {
  const stride = Math.ceil(profile.width / 8);
  const byte = y * stride + (x >> 3);
  const mask = 1 << (7 - (x & 7));
  return Boolean(bitmap[byte] & mask);
};

export const setPixel = (bitmap, profile, x, y, enabled) => {
  if (x < 0 || y < 0 || x >= profile.width || y >= profile.height) return bitmap;
  const next = Uint8Array.from(bitmap);
  const stride = Math.ceil(profile.width / 8);
  const byte = y * stride + (x >> 3);
  const mask = 1 << (7 - (x & 7));
  if (enabled) next[byte] |= mask;
  else next[byte] &= 0xff ^ mask;
  return next;
};

export const countPixels = (bitmap, profile) => {
  let count = 0;
  for (let y = 0; y < profile.height; y++) {
    for (let x = 0; x < profile.width; x++) {
      if (getPixel(bitmap, profile, x, y)) count++;
    }
  }
  return count;
};
